module.exports = __webpack_public_path__ + "assets/img/my-vpp-bg-1.b704dcb0.png";